import Withdraw from './withdraw-new';

export default Withdraw;
